import request from '../request'
import qs from 'qs'
// 支付接口
const pay = (data) => {
  return request.get(
    `/api/medilinkPay/checkoutCounter/pay?${qs.stringify(data)}`,
    data
  )
}
// 获取银行卡信息
const getBankCardInfo = (data) => {
  return request.get(`/api/medilinkPay/getBankCardInfo?bankCardNumber=${data}`)
}
// 获取验证码
const agreementApply = (data) => {
  return request.post('/api/medilinkPay/agreementApply', data)
}
// 支付申请
const applyPay = (data) => {
  return request.post('/api/medilinkPay/payApply', data)
}
// 同意确认协议
const agreementConfirm = (data) => {
  return request.post('/api/medilinkPay/agreementConfirm', data)
}
// 重新获取验证码
const reGetPayCode = (data) => {
  return request.post('/api/medilinkPay/reSendPaymentSms', data)
}
// 确认支付
const confirmPay = (data) => {
  return request.post('/api/medilinkPay/payConfirm', data)
}
// 银行卡解绑
const unbindBankCard = (data) => {
  return request.post('/api/medilinkPay/unBindCard', data)
}
// 查询支付结果
const getOrderStatus = (data) => {
  return request.post('/api/medilinkPay/checkoutCounter/getOrderStatus', {
    notLoading: true,
    ...data
  })
}
export default {
  pay,
  getBankCardInfo,
  agreementApply,
  applyPay,
  agreementConfirm,
  reGetPayCode,
  confirmPay,
  unbindBankCard,
  getOrderStatus
}
